<div class="AmInputPickerForm" [formGroup]="formGroup" #contentPickerForm (click)="toggleDate()"
  (focusout)="focusOutDate()" [ngClass]="{'AmInputPickerForm--readOnly': readOnly}">
  <div class="AmInputPickerForm--wrap" [ngClass]="{'input--error': (textControl.touched && textControl.invalid),'input--readOnly': readOnly}">
    <div class="AmInputPickerForm--wrap--content">
      <label [ngClass]="{'label--focus-am': focusInput}">
        {{ label | translate }}
      </label>
      <input [hidden]="optionsSelect"
        (blur)="focusOutDate()"
        (focus)="toggleDate($event)"
        [(ngModel)]="val"
        [currentFormGroup]="formGroup"
        [formControl]="textControl"
        [formControlName]="nameInput"
        [id]="nameInput"
        [isFloat]="false"
        [mask]="mask"
        [dropSpecialCharacters]="dropSpecialCharacters"
        [nameList]="nameList"
        [ngClass]="{'input--focus-am': focusInput, 'input--disabled': isDisabled}"
        [placeholder]="placeholder | translate"
        [readOnly]="readOnly || nameInput === 'nationality'"
        [showNav]="true"
        [type]="type"
        [themeLightScroll]="themeLightScroll"
        [maxlength]="maxlength"
        [minlength]="minlength"
        [pattern]="pattern"
        (mousedown)="nameInput === 'nationality' ? $event.preventDefault() : null"
        #inputElement
        appAmKeyboard
        autocomplete="off"
      />
      <input [hidden]="!optionsSelect"
        [(ngModel)]="val"
        [formControl]="textControl"
        [formControlName]="nameInput"
        [id]="nameInput"
        [mask]="mask"
        [dropSpecialCharacters]="dropSpecialCharacters"
        [ngClass]="{'input--focus-am': focusInput, 'input--disabled': isDisabled}"
        [placeholder]="placeholder | translate"
        [readOnly]="readOnly || nameInput === 'nationality'"
        [type]="type"
        (mousedown)="nameInput === 'nationality' ? $event.preventDefault() : null"
        [minlength]="minlength"
        #inputElement
        autocomplete="off"
      />
    </div>
    <div class="AmInputPickerForm--wrap--actions">
      <button disabled type="button" [ngClass]="{'button--focus-am': val,  'button--disabled': isDisabled}" [ngStyle]="getIconButton">
      </button>
    </div>
  </div>
  <div *ngIf="!readOnly">
    <span class="message-error text-nowrap" *ngIf="(textControl?.touched && textControl?.hasError('required'))">
      {{ errorRequired | translate | truncate:limitChars }}
    </span>
    <span class="message-error text-nowrap"
      *ngIf="(textControl?.touched && textControl?.hasError('pattern')) || textControl?.value && textControl?.hasError('pattern')">
      {{ errorPattern | translate }}
    </span>
    <span class="message-error text-nowrap"
      *ngIf="(textControl?.touched && textControl?.value && textControl?.hasError('nameForm'))">
      {{ textControl?.getError('nameForm') | translate }}
    </span>
    <span class="message-error text-nowrap"
      *ngIf="(textControl?.touched && textControl?.value && hasErrorCustomError == true)">
      {{ errorCustomError | translate }}
    </span>
  </div>
</div>
